import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useTheme } from '@mui/system';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useLogUserActionMutation } from '../../../api/packSlice';

function PackListEntry({ pack, physicianId, campaignId }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [submitUserAction] = useLogUserActionMutation();

    // Status mapping for dot color and text
    const statusMap = {
        'in-progress': { color: theme.palette.yellow.inProgress, text: 'Review In Progress' }, // yellow-orange
        'open': { color: theme.palette.blue.main, text: 'Not Reviewed' }, // blue
        'submitted': { color: theme.palette.green.taskText, text: 'Review Complete' }, // green
    };
    // Fallback if status is not mapped
    const status = statusMap[pack.pack_status] || { color: theme.palette.text.secondary, text: pack.pack_status };

    const handleClick = async () => {
        // Log entry into pack
        submitUserAction({ action: 'entry_into_pack_review', data: { packReviewId: pack.id, physicianId, campaignId } }).unwrap();
        navigate(`/physician/${physicianId}/packs/${pack.id}`, {state : {
            campaignId: campaignId || null,
        }});
    };

    return (
        <Box onClick={handleClick} sx={{
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: 2,
            cursor: 'pointer',
            transition: 'box-shadow 0.2s',
            '&:hover': { boxShadow: 4 },
        }}>
            <Stack p={2} direction="row" alignItems="center" justifyContent="space-between">
                <Stack spacing={1}>
                    <Typography variant="normal" sx={{ fontSize: '14px' }}>{pack.pack_name}</Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        { pack.pack_status === 'submitted' && <CheckCircleRoundedIcon fontSize='small' sx={{ color: status.color }} />}
                        { pack.pack_status !== 'submitted' && <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: status.color }} /> }
                        <Typography variant="normal" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>{status.text}</Typography>
                    </Stack>
                </Stack>
                <ChevronRightRoundedIcon sx={{ color: theme.palette.text.secondary, fontSize: 28 }} />
            </Stack>
        </Box>
    );
}

export default PackListEntry;